import { createSelector } from 'reselect';
import type { RootState } from './index';

// Patients selectors
const selectPatientsState = (state: RootState) => state.patients;

export const selectPatientsItems = createSelector(
  selectPatientsState,
  (ps) => ps.items
);

export const selectPatientById = (patientId: number | null) => createSelector(
  selectPatientsItems,
  (items) => items.find(p => p.id === patientId) ?? null
);

// Meetings selectors (example)
export const selectMeetingsState = (state: RootState) => state.meetings;

export const selectMeetingsByPatient = (patientId: number | null) => createSelector(
  selectMeetingsState,
  (ms) => {
    if (!patientId) return { items: [], totalCount: 0 };
    return ms.byPatient[patientId] ?? { items: [], totalCount: 0 };
  }
);

// Selector for per-patient current page (returns 1 when not set)
export const selectCurrentPageForPatient = (patientId: number | null) => createSelector(
  selectMeetingsState,
  (ms) => {
    if (!patientId) return 1;
    return ms.byPatient[patientId]?.currentPage ?? 1;
  }
);
